import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import { formatSpacedNumber } from '../../../../../../../../utils/format';
import { CoApplicantDebtData } from '../../../../../../FormData.fi.types';
import { radioOptions } from '../../../../../config/globals';
import { gridColumns } from '../../../../../config/layouts/grid';
import styles from '../../../../../loan.module.scss';
import { personalDebtOutstandingAmountFieldOption } from './config';

export const PersonalDebt = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const hasPersonalDebt = watch('Frontend/HasPersonalDebt') === 'Yes';

  return (
    // TODO: Fix Style Its jumping due to Two Lines Label and two lines error message
    <Grid columns={gridColumns} className={styles.itemsEnd}>
      <RadioFieldUI<CoApplicantDebtData>
        name="Frontend/HasPersonalDebt"
        label={t('CoApplicantDebt.Personal.question')}
        data-testid="has-personal-debt-input"
        options={radioOptions}
        radioStyle="both"
      />

      {hasPersonalDebt && (
        <NumberFieldUI<CoApplicantDebtData>
          name="CoDebt/Personal/OutstandingAmount"
          label={t('CoApplicantDebt.Personal.OutstandingAmount.label')}
          data-testid="debt-personal-outstanding-amount-input"
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          {...personalDebtOutstandingAmountFieldOption}
        />
      )}
    </Grid>
  );
};
